const Arrow = ({ turn }) => {

  const direction = {
    'right': '-rotate-90',
    'left': 'rotate-90',
    'up': 'rotate-180',
    'down': ''
  }

  return (
    <svg
        className={`h-6 w-5 shrink-0 transition-transform ${direction[turn]}`}
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z"/>
      </svg>
  )
}

export default Arrow;
